export default {
  title: '时区',
  currentTime: '当前时间',
  pinned: '常用',
  prev: '上一个时区',
  next: '下一个时区',
  confirm: '确认切换',
  hint: '滚轮或方向键切换时区，确认后重新载入页面',
  cities: {
    m720: '国际日期变更线以西',
    m660: '中途岛',
    m600: '夏威夷',
    m540: '阿拉斯加',
    m480: '蒂华纳、下加利福尼亚、太平洋时间(美国和加拿大)',
    m420: '亚利桑那、奇瓦瓦、拉巴斯、马萨特兰、山地时间(美国和加拿大)',
    m360: '瓜达拉哈拉、墨西哥城、蒙特雷、萨斯喀彻温、中美洲、中部时间(美国和加拿大)',
    m300: '印地安那(东部)、波哥大、利马、基多、东部时间(美国和加拿大)、加拉加斯',
    m240: '亚松森、圣地亚哥、乔治敦、拉巴斯、圣胡安、马瑙斯、大西洋时间(加拿大)、纽芬兰',
    m180: '卡宴、格陵兰、布宜诺斯艾利斯、巴西利亚、蒙得维的亚',
    m120: '中大西洋',
    m60: '亚速尔群岛、佛得角群岛',
    p0: '卡萨布兰卡、都柏林、爱丁堡、里斯本、伦敦、蒙罗维亚、雷克雅未克、协调世界时',
    p60: '阿姆斯特丹、柏林、伯尔尼、罗马、斯德哥尔摩、维也纳、萨拉热窝、斯科普里、华沙、萨格勒布、布鲁塞尔、哥本哈根、马德里、巴黎、贝尔格莱德、布拉迪斯拉发、布达佩斯、卢布尔雅那、布拉格、中非西部',
    p120: '雅典、布加勒斯特、伊斯坦布尔、安曼、温得和克、耶路撒冷、开罗、哈拉雷、比勒陀利亚、贝鲁特、赫尔辛基、基辅、里加、索非亚、塔林、维尔纽斯、明斯克',
    p180: '科威特、利雅得、第比利斯、内罗毕、巴格达、莫斯科、圣彼得堡、伏尔加格勒、德黑兰',
    p240: '阿布扎比、马斯喀特、埃里温、巴库、路易港、喀布尔',
    p300: '伊斯兰堡、卡拉奇、叶卡捷琳堡、塔什干、斯里加亚渥登普拉、钦奈、加尔各答、孟买、新德里、加德满都',
    p360: '阿斯塔纳、达卡、阿拉木图、新西伯利亚、仰光',
    p420: '克拉斯诺亚尔斯克、曼谷、河内、雅加达',
    p480: '伊尔库茨克、乌兰巴托、吉隆坡、新加坡、珀斯、台北、北京、重庆、香港特别行政区、乌鲁木齐',
    p540: '首尔、雅库茨克、大阪、札幌、东京、阿德莱德、达尔文',
    p600: '符拉迪沃斯托克、堪培拉、墨尔本、悉尼、关岛、莫尔兹比港、布里斯班、霍巴特',
    p660: '马加丹、所罗门群岛、新喀里多尼亚',
    p720: '奥克兰、惠灵顿、斐济、马绍尔群岛、彼得罗巴甫洛夫斯克-堪察加',
    p780: '萨摩亚群岛、努库阿洛法',
    p840: '基里巴斯、莱恩群岛'
  }
};
